export default "__VITE_ASSET__d04ce532__"